import ApplicationController from "../../../application_controller";

export default class extends ApplicationController {
    connect() {
        if (!this.zIndex) {
            this.zIndex = 10;
        }
    }

    setZIndex(element) {
        this.zIndex += 10;
        element.style.zIndex = this.zIndex;
    }
}
